import React from "react";
import {
  MainHeader,
  Container,
  Title,
  NullDescription,
  NullMessage,
  NullPage,
  Controls,
  SearchDiv,
  FilterDiv,
} from "./styles";
import {
  Button,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Check, Close, FilterList } from "@mui/icons-material";
import { StickyTable } from "../../components/StickyTable";
import Spinner from "../../components/Spinner/Spinner";
import { getUsersList } from "../../services/user/getUser";
import theme from "../../theme/theme";
import { EditUser } from "../EditUser";
import { SearchBar } from "../../components/SearchBar";

const UsersList = () => {
  // ------------------- JWT -------------------
  const jwt = localStorage.getItem("jwt");
  const userID = localStorage.getItem("user_id");

  // ------------------- STATES -------------------
  const [loadingUsersList, setLoadingUsersList] = React.useState(false);
  const [usersList, setUsersList] = React.useState<any>(null);
  const [usersListData, setUsersListData] = React.useState<any>(null);
  const [isEmpty, setIsEmpty] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState<string>('');
  const [filterQuery, setFilterQuery] = React.useState<string>('');

  // ------------------- USE EFFECT -------------------
  React.useEffect(() => {
    getUsers();
  }, []);

    React.useEffect(() => {
    }, [usersList]);

  // ------------------- GET USERS FROM API -------------------
  const getUsers = async () => {
    setLoadingUsersList(true);
    await getUsersList(jwt!)
      .then((res: any) => {
        if (res && res.data) {
          setUsersList(res.data);
          handleData(res.data);
          if (res.data.length === 0) {
            setIsEmpty(true);
          } else {
            setIsEmpty(false);
          }
        }
      })
      .catch((err: any) => {
        console.log(err, "err");
      });

    setLoadingUsersList(false);
  };

  // ------------------- TABLE PARAMS -------------------
  const usersCols = [
    { id: "active", label: "Activo", minWidth: 100 },
    { id: "user_type", label: "Tipo de usuario", minWidth: 100 },
    { id: "name", label: "Nombre", minWidth: 170 },
    { id: "email", label: "Correo", minWidth: 190 },
    { id: "actions", label: "Acciones", minWidth: 100 },
  ];

  // ------------------- HANDLE FUNCTIONS -------------------
  const handleData = (res: any) => {
    const resFiltered = res.filter(
      (user: any) => user.id !== parseInt(userID!)
    );
    console.log("resFiltered: ", userID);
    const usersListRows = resFiltered.map((user: any) => ({
      active: isActive(user.blocked, user.deleted),
      user_type: isAdmin(user.user_type),
      name: user.name + " " + user.lastname,
      email: user.email,
      actions: (
        <>
          <Button>
            <EditUser userID={user.id} onClose={() => getUsers()} />
          </Button>
        </>
      ),
    }));

    setUsersListData(usersListRows);
  };

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  
    // Obtener el tipo de usuario seleccionado en el filtro
    const userTypeFilter =
        filterQuery === 'Administradores' ? 1 : filterQuery === 'Usuarios' ? 2 : null;
  
    const filtered = usersList.filter(
      (user: any) =>
        (user.name.toLowerCase().includes(query.toLowerCase()) ||
          user.lastname.toLowerCase().includes(query.toLowerCase()) ||
          user.email.toLowerCase().includes(query.toLowerCase())) &&
        (userTypeFilter === null || user.user_type === userTypeFilter)
    );
  
    handleData(filtered);
  };

  const handleSelect = (query: string) => {
    setFilterQuery(query);
    const userTypeFilter =
      query === 'Administradores' ? 1 : query === 'Usuarios' ? 2 : null;
  
    let filteredList = usersList;
  
    if (query !== 'Todos los usuarios') {
      filteredList = filteredList.filter(
        (user: any) => user.user_type === userTypeFilter
      );
    }
  
    if (searchQuery) {
      filteredList = filteredList.filter(
        (user: any) =>
          user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.lastname.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.email.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
  
    handleData(filteredList);
  };
  
  

  function isActive(blocked: any, deleted: any) {
    if (!blocked && !deleted) {
      return <Check sx={{ color: theme.color.lemon, fontSize: "36px" }} />;
    } else {
      return <Close sx={{ color: theme.color.ruby, fontSize: "36px" }} />;
    }
  }

  function isAdmin(userType: any) {
    if (userType === 1) {
      return "Administrador";
    } else {
      return "Usuario normal";
    }
  }

  return (
    <>
      <Container>
        {/* <MainHeader>Lista de usuarios</MainHeader> */}
        <MainHeader>
          <Title>Usuarios</Title>
        </MainHeader>
        <Controls>
          <SearchDiv >
          <SearchBar
            onSearch={handleSearch}
            placeholder="Busca un usuario por nombre, apellido o email"
            width="100%"
          />
          </SearchDiv>
          <FilterDiv>
          <FormControl sx={{width: "100%" }}>
            <InputLabel id="demo-simple-select-autowidth-label" />
            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              autoWidth
              sx={{
                borderRadius: "50px",
                boxShadow: "0px 4px 4px 0px #00000040",
                height: "44px",
              }}
              displayEmpty
              startAdornment={<FilterList sx={{marginRight: '10px'}}/>}
              renderValue={(selected: any) => {
                if (!selected) {
                    return <em>Filtrar</em>;
                } 
                return selected
              }}
              onChange={(event) => handleSelect(event.target.value)}
            >
              <MenuItem disabled value="">
                <em>Filtrar</em>
              </MenuItem>
              <MenuItem value={'Todos los usuarios'}>Todos los usuarios</MenuItem>
              <MenuItem value={'Administradores'}>Administradores</MenuItem>
              <MenuItem value={'Usuarios'}>Usuarios</MenuItem>
            </Select>
          </FormControl>
          </FilterDiv>
        </Controls>
        {!loadingUsersList && usersListData ? (
          isEmpty ? (
            <NullPage>
              <NullMessage>No hay usuarios</NullMessage>
              <NullDescription>
                No hay usuarios registrados en el sistema
              </NullDescription>
            </NullPage>
          ) : (
            <>
              <Divider sx={{ marginBottom: "20px", marginTop: "20px" }} />
              <StickyTable columns={usersCols} rows={usersListData} />
            </>
          )
        ) : (
          <Spinner />
        )}
      </Container>
    </>
  );
};

export default UsersList;
